import { Button, Card, ControlGroup, Dialog, DialogFooter, Divider, InputGroup, Label } from '@blueprintjs/core'
import React from 'react'
import Client from '../../../../client'
import Spinner from '../../../../components/Spinner'
import config from '../../../../config'

interface Props {
  query?: any
  categoryMarketCategoryId?: any
  value?: any
  onChange?: any
}
interface State {
  loading: boolean
  modalOpen: boolean
  query: string
  results: any[] | null
}
export default class EpidPicker extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      loading: false,
      modalOpen: false,
      query: props.query || '',
      results: []
    }
  }

  onOpen = () => {
    this.setState({
      modalOpen: true
    })
  }

  onClose = () => {
    this.setState({
      results: [],
      modalOpen: false
    })
  }

  search = async () => {
    this.setState({ loading: true, results: [] })
    const { query } = this.state

    const res = await Client.relatedEbayProducts({
      query,
      categoryId: this.props.categoryMarketCategoryId
    })

    this.setState({
      results: res.data.products,
      loading: false
    })
  }

  render() {
    return (
      <div>
        <Label style={{ marginBottom: 5 }}>Ebay Product ID</Label>
        <ControlGroup vertical={false}>
          <InputGroup
            placeholder={String(config.MAGIC_NUMBER)}
            value={this.props.value}
            onChange={e => this.props.onChange(e.currentTarget.value)}
          />
          <Button onClick={this.onOpen} icon="filter">
            {this.props.value ? 'Change EPID' : 'Find EPID'}
          </Button>
        </ControlGroup>
        <Dialog
          style={{ maxWidth: '960px', width: '95%' }}
          onClose={this.onClose}
          isOpen={this.state.modalOpen}
          title="Choose Ebay Product ID"
        >
          <div style={{ padding: 20 }}>
            <Label style={{ marginBottom: 5 }}>Search for related products</Label>
            <ControlGroup fill vertical={false}>
              <InputGroup
                placeholder="Apple iPad"
                value={this.state.query}
                disabled={this.state.loading}
                onChange={e => this.setState({ query: e.currentTarget.value })}
              />
              <Button style={{ maxWidth: 60 }} disabled={this.state.loading} onClick={this.search} icon="filter" />
            </ControlGroup>
            <Divider style={{ margin: '20px 0 10px' }} />
            {this.state.loading && <Spinner />}
            {this.state.results === null && <p>No results found with query and category combination</p>}

            <div
              className="ebay-product"
              style={{
                maxHeight: '70vh',
                minHeight: 300,
                overflow: 'scroll',
                display: 'grid',
                gridTemplateColumns: 'repeat(4, 1fr)',
                gridGap: '20px'
              }}
            >
              {(this.state.results || []).map(p => (
                <Card
                  onClick={() => this.props.onChange(p.epid)}
                  role="button"
                  tabIndex={0}
                  key={p.epid}
                  elevation={1}
                  interactive
                  style={{
                    padding: 10,
                    border: p.epid === this.props.value ? '1px solid #106BA3' : '1px solid transparent'
                  }}
                >
                  <div>
                    <h6>{p.name}</h6>
                    <img alt="" src={p.imageUrl} style={{ maxHeight: '130px', display: 'block', margin: 'auto' }} />
                  </div>
                </Card>
              ))}
            </div>
          </div>
          <DialogFooter actions={<Button onClick={this.onClose}>Close</Button>} />
        </Dialog>
      </div>
    )
  }
}
